export enum CTAButtonVariant {
  FILLED = 'filled',
  OUTLINE = 'outline',
}
